export default __webpack_public_path__ + "static/media/Benefits of Quitting.3697270b.png";